import type { FileExtension } from './types';

export const PROD_ORIGIN = 'https://classical.music.apple.com';

export const ARTWORK_META_TAG_DEFAULTS: {
    crop: CropCode;
    fileType: FileExtension;
    height: number;
    width: number;
    quality: number;
} = {
    crop: 'bb',
    fileType: 'webp',
    height: 630,
    width: 1200,
    quality: 60,
};

export const SHARING_ARTWORK_FALLBACK: {
    url: string;
    width: number;
    height: number;
} = {
    url: '/assets/meta/apple-music-classical.png',
    width: 1200,
    height: 630,
};

/**
 * Image settings
 */
const baseWidthHeightRegex = '({w}|[0-9]+)x({h}|[0-9]+)';
const baseFileTypeRegex = '{f}|([a-zA-Z]{3,4})';
const baseEffectCropCode = '[A-z]{1,6}\\.[\\w]{1,8}';

export const QUALITY_PARAM_REGEX = /-[0-9]+\.(\{f\}|[A-z]{2,4})$/;
export const FILE_TYPE_REGEX = new RegExp(baseFileTypeRegex);
export const EMBEDDED_CROP_CODE_REGEX = new RegExp(
    `^${baseWidthHeightRegex}([a-zA-Z]+)`,
);
export const EFFECT_ID_REGEX = new RegExp(
    `^${baseWidthHeightRegex}(${baseEffectCropCode})\\.(${baseFileTypeRegex})`,
);

// Need to disable cast rule on file extensions otherise they
// get referenced as a `string` type.
// tslint:disable-next-line:no-useless-cast
export const FILE_EXTENSIONS = ['jpg', 'webp', 'png'] as const;

// https://confluence.sd.apple.com/pages/viewpage.action?spaceKey=AMPDSCE&title=Crop+Code+Master+List
// Need to disable cast rule on crop codes otherise they
// get referenced as a `string` type.
// tslint:disable-next-line:no-useless-cast
export const ALL_CROP_CODES = [
    'at',
    'ac',
    'bb',
    'bw',
    'bf',
    'br',
    'h',
    'w',
    'cc',
    'cx',
    'ca',
    'cb',
    'cw',
    'cu',
    'cy',
    'cv',
    'rc',
    'rs',
    'sr',
    'ss',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff',
    'fg',
    'fh',
    'fi',
    'fj',
    'fk',
    'fl',
    'fm',
    'fn',
    'fo',
    'fp',
    'fq',
    'fr',
    'fs',
    'ft',
    'fu',
    'fv',
    'fw',
    'fx',
    'fy',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'eg',
    'eh',
    'ei',
    'ej',
    'ek',
    'el',
    'em',
    'en',
    'eo',
    'ep',
    'eq',
    'er',
    'es',
    'et',
    'eu',
    'ev',
    'ew',
    'ex',
    'ey',
    'ez',
    'ga',
    'gb',
    'gc',
    'lg',
    'lw',
    'lc',
    'ld',
    'la',
    'lb',
    'lt',
    'lh',
    'mv',
    'mw',
    'mf',
    'nr',
    'sy',
    'sx',
    'sz',
    'sa',
    'sb',
    'sc',
    'sd',
    'se',
    'sf',
    'sg',
    'sh',
    'si',
    'sj',
    'sk',
    'va',
    'vb',
    'vc',
    'vd',
    've',
    'vf',
    'wp',
    'wa',
    'wb',
    'wc',
    'wd',
    'we',
    'wf',
    'wg',
    'wv',
    'wx',
    'wy',
    'wz',
    'ta',
    'tb',
    'tc',
    'td',
    'oa',
    'ob',
    'oc',
    'od',
    'oe',
    'of',
    'og',
    'oh',
] as const;
